import { defaultFill } from '../utils/constants';
var muiSnailMail16 = {
    paths: [
        {
            path: 'M2,9 L14,9 L14,4.00236948 C14,2.89574381 13.1056209,2 12.0037973,2 L3.99620271,2 C2.8942306,2 2,2.89566171 2,4.00236948 L2,9 Z M12,11 L12,14.009222 C12,14.5564136 11.5490248,15 11.009222,15 L6.99077797,15 C6.44358641,15 6,14.5490248 6,14.009222 L6,11 L1.00087166,11 C0.448105505,11 0,10.555163 0,10.0044225 L0,4.00236948 C0,1.79192185 1.78883037,0 3.99620271,0 L12.0037973,0 C14.2108391,0 16,1.79182182 16,4.00236948 L16,10.0044225 C16,10.5542648 15.5553691,11 14.9991283,11 L12,11 L12,11 Z M4,0 C6.20724676,0 8,1.79321343 8,3.99686968 L8,3.99686968 L8,4 L12.009222,4 C12.5490248,4 13,4.45190985 13,5.0093689 L13,5.0093689 L13,6.9906311 C13,7.55664682 12.5527519,8 12.0010434,8 L12.0010434,8 L10.9989566,8 C10.4426603,8 10,7.55228475 10,7 L10,7 L10,6 L8,6 L8,10 L6,10 L6,3.99686968 C6,2.89766803 5.10256233,2 4,2 L4,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Snail Mail',
    width: 16,
    height: 15,
};
var muiSnailMail24 = {
    paths: [
        {
            path: 'M18.9980273,0 C21.7605405,0 24,2.24565156 24,4.99478281 L24,13.992516 C24,14.5489341 23.5525308,15 22.9993054,15 L16,15 L16,18.9970707 C16,19.5509732 15.5469637,20 15.0029699,20 L8.99703014,20 C8.4463856,20 8,19.5621186 8,18.9970707 L8,15 L1.00069463,15 C0.448026248,15 0,14.5510798 0,13.992516 L0,4.99478281 C0,2.23624043 2.23630996,0 5.00197269,0 L18.9980273,0 Z M14,15 L10,15 L10,18 L14,18 L14,15 Z M5,2 C3.34601008,2 2,3.34356266 2,4.99478281 L2,13 L8,13 L8,4.99478281 C8,3.34685583 6.65348982,2 5,2 Z M18.9991284,2 L9,2 C9.62857661,2.83563119 10.0011011,3.87331463 10.0011011,4.99478281 L10.0011011,13 L22.0011011,13 L22.0011011,4.99478281 C22.0011011,3.34703242 20.6538831,2 18.9991284,2 Z M12.9970301,4 L19.0029699,4 C19.5469637,4 20,4.44762906 20,4.99980749 L20,4.99980749 L20,8.00019251 C20,8.55628335 19.5480902,9 18.9906311,9 L18.9906311,9 L17.0093689,9 C16.4433532,9 16,8.55275191 16,8.00104344 L16,8.00104344 L16,6 L13.0093689,6 C12.4433532,6 12,5.55228475 12,5 L12,5 L12.0067078,4.88266744 C12.0643013,4.38272018 12.4857174,4 12.9970301,4 L12.9970301,4 Z',
            fill: defaultFill,
        },
    ],
    title: 'Snail Mail',
    width: 24,
    height: 20,
};
var muiSnailMail = {
    base: muiSnailMail16,
    smIcon: muiSnailMail16,
    lgIcon: muiSnailMail24,
};
export { muiSnailMail };
//# sourceMappingURL=snailMail.js.map